import React from 'react';
import { Link } from 'react-router-dom';

/* الفوتر — مطابق لتصميم الويب (Web-Home): أخضر غامق #003A2F + شعار بصندوق أبيض + بريد فقط */
const Footer: React.FC = () => {
  const col: React.CSSProperties = { display: 'flex', flexDirection: 'column', gap: 10 };
  const head: React.CSSProperties = { fontFamily: "'Cairo', sans-serif", fontSize: 16, fontWeight: 700, color: '#FFFFFF' };
  const lnk: React.CSSProperties = { fontSize: 14, color: '#CFE7DD', textDecoration: 'none' };

  return (
    <footer style={{ background: '#003A2F', color: '#CFE7DD', fontFamily: "'Tajawal', sans-serif", marginTop: 'auto' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '44px 24px 26px', boxSizing: 'border-box', display: 'flex', flexWrap: 'wrap', gap: 32 }}>
        <div style={{ flex: '2 1 260px', display: 'flex', flexDirection: 'column', gap: 12 }}>
          <span style={{ alignSelf: 'flex-start', padding: '8px 14px', borderRadius: 14, background: '#FFFFFF' }}>
            <img src="/aljalab-logo.png" alt="الجلب" style={{ height: 38, width: 'auto', display: 'block' }} />
          </span>
          <p style={{ margin: 0, fontSize: 14, lineHeight: 1.9, maxWidth: 320 }}>
            سوق الحلال — منصة بيع وشراء المواشي والخدمات في السعودية
          </p>
        </div>

        <div style={{ flex: '1 1 160px', ...col }}>
          <span style={head}>روابط سريعة</span>
          <Link to="/ads" style={lnk}>الإعلانات</Link>
          <Link to="/categories" style={lnk}>التصنيفات</Link>
          <Link to="/services" style={lnk}>الخدمات</Link>
          <Link to="/contact" style={lnk}>تواصل معنا</Link>
        </div>

        <div style={{ flex: '1 1 160px', ...col }}>
          <span style={head}>معلومات</span>
          <Link to="/about" style={lnk}>عن الجلب</Link>
          <Link to="/terms" style={lnk}>الشروط والأحكام</Link>
          <Link to="/privacy" style={lnk}>سياسة الخصوصية</Link>
        </div>

        <div style={{ flex: '1 1 200px', ...col }}>
          <span style={head}>تواصل معنا</span>
          <a href="mailto:support@aljalab.com" style={{ fontSize: 14, color: '#FFFFFF', textDecoration: 'none' }}>support@aljalab.com</a>
        </div>
      </div>
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: '16px 24px 20px', boxSizing: 'border-box', borderTop: '1px solid rgba(255,255,255,0.12)', fontSize: 13, textAlign: 'center' }}>
        © {new Date().getFullYear()} الجلب — سوق الحلال. جميع الحقوق محفوظة
      </div>
    </footer>
  );
};

export default Footer;
